export default class ValidationError extends Error {
    constructor(summaryMssg, fullMssg) {
        super(summaryMssg);
        this.FullMssg = fullMssg;   // Can be used to display more information, when summary is clicked - TODO future enhancement of validatiuon error display
        this.name = 'ValidationError';
    }
}